import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductDataForNCash } from '../../../../model/finzy-flex/product-list.model';

@Component({
  selector: 'app-nCash-allocation',
  templateUrl: './nCash-allocation.component.html',
  styleUrls: ['./nCash-allocation.component.css']
})
export class NCashAllocationComponent implements OnInit {

  private matDialogRef: MatDialogRef<NCashAllocationComponent>;
  productInfo: ProductDataForNCash;
  constructor(
    matDialogRef: MatDialogRef<NCashAllocationComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.matDialogRef = matDialogRef;
    this.productInfo = data.productData;
   }

  ngOnInit(): void {
  }

  onClickBack() {
    return this.matDialogRef.close();
  }

}

